/**
 * SOLUCIÓN DEFINITIVA para el problema del worker de PDF.js
 * Este módulo intercepta y corrige la URL del worker antes de que PDF.js la use
 */

const WORKER_URL = '/pdf.worker.min.js';
const CORRECT_VERSION = '3.11.174';

// SOLUCIÓN ULTRA-AGRESIVA: Interceptar fetch ANTES de que PDF.js lo use
// Hacer esto inmediatamente, antes de que cualquier otro código se ejecute
if (typeof window !== 'undefined') {
  // Guardar el fetch original
  const originalFetch = window.fetch ? window.fetch.bind(window) : null;
  
  if (originalFetch) {
    // Sobrescribir fetch con interceptación agresiva
    window.fetch = function(...args) {
      const url = args[0];
      
      // Bloquear cualquier intento de cargar worker incorrecto
      if (typeof url === 'string') {
        // Detectar cualquier URL que contenga pdf.js/5.4.530 o pdf.js/5 (excepto 3.11.174)
        if (url.includes('pdf.js/5.4.530') || 
            (url.includes('pdf.js/5') && !url.includes('3.11.174')) ||
            (url.includes('cdnjs.cloudflare.com/ajax/libs/pdf.js/5') && !url.includes('3.11.174'))) {
          console.warn('[PDF.js Worker Fix] ⚠️ BLOQUEADO fetch a worker incorrecto:', url);
          console.warn('[PDF.js Worker Fix] ✅ Redirigiendo a worker local:', WORKER_URL);
          // Crear una nueva Request con la URL correcta
          const newArgs = [WORKER_URL, ...args.slice(1)];
          return originalFetch(...newArgs);
        }
      }
      
      return originalFetch(...args);
    };
    
    console.log('[PDF.js Worker Fix] ✅ Fetch interceptado y protegido');
  }
  
  // También interceptar XMLHttpRequest por si acaso
  if (window.XMLHttpRequest) {
    const OriginalXHR = window.XMLHttpRequest;
    window.XMLHttpRequest = function(...args) {
      const xhr = new OriginalXHR(...args);
      const originalOpen = xhr.open;
      
      xhr.open = function(method, url, ...rest) {
        if (typeof url === 'string' && 
            (url.includes('pdf.js/5.4.530') || 
             (url.includes('pdf.js/5') && !url.includes('3.11.174')))) {
          console.warn('[PDF.js Worker Fix] ⚠️ BLOQUEADO XHR a worker incorrecto:', url);
          console.warn('[PDF.js Worker Fix] ✅ Redirigiendo a worker local:', WORKER_URL);
          return originalOpen.call(this, method, WORKER_URL, ...rest);
        }
        return originalOpen.call(this, method, url, ...rest);
      };
      
      return xhr;
    };
    console.log('[PDF.js Worker Fix] ✅ XMLHttpRequest interceptado y protegido');
  }
}

// Interceptar errores de import dinámico
if (typeof window !== 'undefined') {
  // Interceptar errores de import dinámico
  window.addEventListener('error', (event) => {
    const errorMsg = event.message || event.error?.message || '';
    if (errorMsg.includes('pdf.js/5.4.530') || 
        errorMsg.includes('Failed to fetch dynamically imported module') ||
        (errorMsg.includes('pdf.js/5') && !errorMsg.includes('3.11.174'))) {
      console.warn('[PDF.js Worker Fix] ⚠️ Error de import dinámico detectado:', errorMsg);
      // Forzar el worker correcto después de un breve delay
      setTimeout(() => {
        if (window.pdfjsLib && window.pdfjsLib.GlobalWorkerOptions) {
          window.pdfjsLib.GlobalWorkerOptions.workerSrc = WORKER_URL;
          console.log('[PDF.js Worker Fix] ✅ Worker forzado después de error');
        }
      }, 10);
    }
  }, true);
  
  // Interceptar rechazos no manejados de promesas
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason?.message || event.reason?.toString() || '';
    if (reason.includes('pdf.js/5.4.530') || 
        reason.includes('Failed to fetch dynamically imported module')) {
      console.warn('[PDF.js Worker Fix] ⚠️ Rechazo no manejado detectado:', reason);
      event.preventDefault();
      // Forzar el worker correcto
      if (window.pdfjsLib && window.pdfjsLib.GlobalWorkerOptions) {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = WORKER_URL;
        console.log('[PDF.js Worker Fix] ✅ Worker forzado después de rechazo');
      }
    }
  }, true);
}

export { WORKER_URL, CORRECT_VERSION };
